import * as React from 'react';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {hideAtomByDefault} from '../utils';
import {USYS_DATA_ATTRS} from '@packages/systems/users/constants';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const UserAccountSubscriptionListEmptyState = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    context,
    sharedContext,
    data,
    renderChild,
  }) => {
    const props = generateAttributes(attributes, classes);
    const shouldShowInDesigner = context.get('uiState') === 'empty';
    const runtimeEnvironment = useRuntimeEnvironment();

    return (
      <div
        {...hideAtomByDefault(
          sharedContext,
          shouldShowInDesigner,
          runtimeEnvironment
        )(props)}
        {...{[USYS_DATA_ATTRS.userSubscriptionsEmptyState]: true}}
      >
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, context)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Empty State',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Users'), iconName('AccountSubscriptionList')),
  },
  render: UserAccountSubscriptionListEmptyState,
  uiStateOnSelected: 'empty',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'UserAccountSubscriptionListWrapper', rule: 'ExactlyOne'}],
    pinToParent: true,
  },
  lockedStyles: {
    display: {
      when: true,
      message:
        "The display setting can't be changed for a subscription list's empty state.",
    },
  },
  fields: {
    children: TListOfElement,
  },
});

export default config;
